export const getMainDomain = () => process.env.REACT_APP_ARTIST_BASE_DOMAIN;